import React from "react";
import { portfolioData } from "../data/portfolioData";
import LaserFlow from "../components/ui/LaserFlow";
import {
  SiNodedotjs,
  SiExpress,
  SiMongodb,
  SiMysql,
  SiPostgresql,
  SiReact,
  SiRedux,
  SiAngular,
  SiAmazon,
  SiSocketdotio,
} from "react-icons/si";

const techIcons = [
  { label: "Node.js", icon: SiNodedotjs },
  { label: "Express", icon: SiExpress },
  { label: "MongoDB", icon: SiMongodb },
  { label: "MySQL", icon: SiMysql },
  { label: "PostgreSQL", icon: SiPostgresql },
  { label: "React", icon: SiReact },
  { label: "Redux", icon: SiRedux },
  { label: "Angular", icon: SiAngular },
  { label: "AWS", icon: SiAmazon },
  { label: "WebSockets", icon: SiSocketdotio },
];

const Hero = () => {
  const { name, role, about, location, email, skills, hero } = portfolioData;

  return (
    <section id="hero" className="relative overflow-hidden py-16 md:py-24 scroll-mt-24">
      <div className="pointer-events-none absolute inset-0 opacity-65">
        <LaserFlow
          color="#8fdcff"
          horizontalBeamOffset={0.05}
          verticalBeamOffset={0.02}
          horizontalSizing={0.45}
          verticalSizing={1.8}
          wispDensity={1}
          wispSpeed={14}
          wispIntensity={5}
          flowSpeed={0.35}
          flowStrength={0.25}
          fogIntensity={0.45}
          fogScale={0.32}
          fogFallSpeed={0.6}
          decay={1.08}
          falloffStart={1.25}
        />
      </div>
      <div className="mx-auto grid max-w-6xl gap-10 px-4 lg:grid-cols-[1.2fr_0.8fr]">
        <div className="rounded-3xl border border-slate-700/60 bg-slate-900/60 p-8 shadow-2xl shadow-cyan-900/20">
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-cyan-300">
            {hero.tagline}
          </p>
          <h1 className="mt-4 text-4xl font-bold leading-tight text-white md:text-6xl">
            {name}
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300">
            {about}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3 text-sm text-slate-300">
            <span className="rounded-full border border-slate-700 px-3 py-1">
              {hero.locationIcon} {location}
            </span>
            <span className="rounded-full border border-slate-700 px-3 py-1">{email}</span>
          </div>
          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href="/Resume.pdf"
              download="Chetan_Jindal_Resume.pdf"
              className="rounded-full bg-cyan-300 px-6 py-3 text-sm font-semibold text-slate-900 transition hover:bg-cyan-200"
            >
              {hero.resumeLabel}
            </a>
            <a
              href="#contact"
              className="rounded-full border border-slate-600 px-6 py-3 text-sm font-semibold text-slate-100 transition hover:border-cyan-300 hover:text-cyan-300"
            >
              {hero.contactLabel}
            </a>
          </div>
        </div>

        <aside className="rounded-3xl border border-slate-700/60 bg-slate-900/50 p-6">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-cyan-300">
            {hero.snapshotTitle}
          </p>
          <ul className="mt-5 space-y-4 text-sm text-slate-200">
            <li>
              <span className="text-slate-400">{hero.snapshotRoleLabel}</span> {role}
            </li>
            <li>
              <span className="text-slate-400">{hero.snapshotLocationLabel}</span>{" "}
              {location}
            </li>
            <li>
              <span className="text-slate-400">{hero.snapshotStackLabel}</span>{" "}
              {skills.slice(0, 5).join(", ")}
            </li>
          </ul>
        </aside>
      </div>

      <div className="mx-auto mt-8 max-w-6xl px-4">
        <div className="overflow-hidden rounded-2xl border border-slate-700/60 bg-slate-900/50 py-4">
          <div className="marquee-track flex items-center gap-10 whitespace-nowrap px-6">
            {[...techIcons, ...techIcons].map((item, index) => {
              const Icon = item.icon;
              return (
                <span
                  key={`${item.label}-${index}`}
                  className="inline-flex items-center gap-2 text-sm text-slate-200"
                >
                  <Icon className="text-lg text-cyan-300" />
                  {item.label}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
